// Engage by default
STUDIP.BigImageHandler.enable();
